import React from 'react';
import { polyglot } from '../../../assets/locales';
import { CalculationUtils, formatter } from '../../../utility';

/**
 * @returns {html} - Generates breakdown for each year. Uses modifier variable to attach italics for year 2 and 3.
 */
const YEAR_ONE = 1;
const YEAR_TWO = 2;
const YEAR_THREE = 3;

const generateCalculation = (cpi, year, item1, item2, item3, item4, item5, style) => {
  const modifier = !!style ? '-' + style : '';
  let remainingAmountText = '';
  if (year === YEAR_ONE) remainingAmountText = polyglot.t('step2.increaseBreakdown.remainingAmount1');
  if (year === YEAR_TWO) remainingAmountText = polyglot.t('step2.increaseBreakdown.remainingAmount2');
  if (year === YEAR_THREE) remainingAmountText = polyglot.t('step2.increaseBreakdown.remainingAmount3');

  const increaseAmount = () => {
    if (year === YEAR_ONE) {
      return <>{polyglot.t('step2.increaseBreakdown.increaseAmount')} {cpi.year} ({`${cpi.value.toFixed(1)}%, see rates`} <a href={polyglot.t('step2.increaseBreakdown.cpiRatesUrl')} alt="" target="_blank" rel="noopener noreferrer">here</a>)</>;
    } else {
      return <>{polyglot.t('step2.increaseBreakdown.increaseAmountFutureYears', { year: cpi.year, percentage: cpi.value.toFixed(1) })}</>;
    }
  }
  return (
    <>
      <div className={`breakdown-item${modifier}`}>
        <span className="breakdown-item-cost">{formatter.toAmountDisplay(item1)}</span>
        <span>
          {increaseAmount()}
        </span>
      </div>
      <div className={`breakdown-item${modifier}`}>
        <span className={`breakdown-item-cost${modifier}`}>{formatter.toAmountDisplay(item2)}</span>
        <span>{polyglot.t('step2.increaseBreakdown.rentWithIncrease')}</span>
      </div>
      <div className={`breakdown-item${modifier}`}>
        <span className={`breakdown-item-cost${modifier}`}>{formatter.toAmountDisplay(item3)}</span>
        <span>{polyglot.t('step2.increaseBreakdown.additionalIncrease')}</span>
      </div>
      <div className={`breakdown-item${modifier}`}>
        <span className={`breakdown-item-total${modifier}`}>{formatter.toAmountDisplay(item4)}</span>
        <span>{polyglot.t('step2.increaseBreakdown.rentWithMaxIncrease')}</span>
      </div>
      <div className={`breakdown-item${modifier}`}>
        <span className={`breakdown-item-remaining${modifier}`}>{formatter.toAmountDisplay(item5)}</span>
        <span className={`breakdown-item-remaining-text${modifier}`}>{`${remainingAmountText}`}</span>
      </div>
    </>
  );
};

const FullRentIncreaseBreakdown = (props) => {
  const { cpi, rent, eligibleAmount } = props;
  const cpiPercent = Number((cpi.value / 100).toFixed(3));

  /* YEAR ONE CALCULATIONS */
  const Y1A = CalculationUtils.rentIncreaseAmount(rent, cpiPercent);
  const Y1B = CalculationUtils.rentWithIncrease(rent, Y1A);
  const Y1C = CalculationUtils.maxAdditionalIncrease(Y1B, eligibleAmount);
  const Y1D = CalculationUtils.rentWithAllIncreases(Y1B, Y1C);
  const Y1F = CalculationUtils.remainingAmount(eligibleAmount, Y1C);
  /* YEAR TWO CALCULATIONS */
  const Y2A = CalculationUtils.rentIncreaseAmount(Y1D, cpiPercent);
  const Y2B = CalculationUtils.rentWithIncrease(Y1D, Y2A);
  const Y2C = CalculationUtils.maxAdditionalIncrease(Y2B, Y1F);
  const Y2D = CalculationUtils.rentWithAllIncreases(Y2B, Y2C);
  const Y2F = CalculationUtils.remainingAmount(Y1F, Y2C);
  /* YEAR THREE CALCULATIONS */
  const Y3A = CalculationUtils.rentIncreaseAmount(Y2D, cpiPercent);
  const Y3B = CalculationUtils.rentWithIncrease(Y2D, Y3A);
  const Y3C = CalculationUtils.maxAdditionalIncrease(Y3B, Y2F);
  const Y3D = CalculationUtils.rentWithAllIncreases(Y3B, Y3C);
  const Y3F = CalculationUtils.remainingAmount(Y2F, Y3C);

  return (
    <div className="breakdown">
      <div className="breakdown-title">
        {polyglot.t('step2.increaseBreakdown.yearOne')}
        {cpi.year})
      </div>
      {generateCalculation(cpi, YEAR_ONE, Y1A, Y1B, Y1C, Y1D, Y1F)}

      <div className="breakdown-title-italic">{polyglot.t('step2.increaseBreakdown.yearTwo', { year: cpi.year + YEAR_ONE })}</div>
      {generateCalculation(cpi, YEAR_TWO, Y2A, Y2B, Y2C, Y2D, Y2F, 'italic')}

      <div className="breakdown-title-italic">{polyglot.t('step2.increaseBreakdown.yearThree', { year: cpi.year + YEAR_TWO })}</div>
      {generateCalculation(cpi, YEAR_THREE, Y3A, Y3B, Y3C, Y3D, Y3F, 'italic')}
    </div>
  );
};

export default FullRentIncreaseBreakdown;